var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShiftsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3047 3H7.6953C4.8306 3 2.5 5.3306 2.5 8.1953V12.8047C2.5 15.6694 4.8306 18 7.6953 18H12.3047C15.1694 18 17.5 15.6694 17.5 12.8047V8.1953C17.5 5.3306 15.1694 3 12.3047 3ZM16.3281 12.8047C16.3281 15.0232 14.5232 16.8281 12.3047 16.8281H7.6953C5.47677 16.8281 3.67188 15.0232 3.67188 12.8047V8.1953C3.67188 5.97677 5.47677 4.17188 7.6953 4.17188H12.3047C14.5232 4.17188 16.3281 5.97677 16.3281 8.1953V12.8047ZM12.719 12.3904C12.9479 12.6192 12.9479 12.9902 12.719 13.219C12.4902 13.4478 12.1192 13.4478 11.8904 13.219L9.58568 10.9143C9.47582 10.8044 9.41409 10.6554 9.41409 10.5V7.04297C9.41409 6.71936 9.67642 6.45703 10 6.45703C10.3236 6.45703 10.586 6.71936 10.586 7.04297V10.2573L12.719 12.3904Z",
    fill: "#65748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftsIcon);
export default __webpack_public_path__ + "static/media/shifts_icon.dd05b571cf30931c687fe9a605320437.svg";
export { ForwardRef as ReactComponent };